import React, { useState, useEffect } from 'react';
import CookieConsent from 'react-cookie-consent';
import { getAssetUrl } from '../services/api';
import { useLocalization } from '../contexts/LocalizationContext';

const CookieBanner = () => {
  const { t } = useLocalization();
  const [showBanner, setShowBanner] = useState(false);

  // t() returns the raw key while translations load - fall back to English
  const tf = (key, fallback) => {
    const translation = t(key);
    return translation === key ? fallback : translation;
  };

  useEffect(() => {
    // Check if user has been informed about cookies
    const cookieNoticeShown = localStorage.getItem('mathLearningCookieNotice');
    if (!cookieNoticeShown) {
      setShowBanner(true);
    }
  }, []);

  const handleGotIt = () => {
    localStorage.setItem('mathLearningCookieNotice', 'true');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <CookieConsent
      location="bottom"
      buttonText={tf('cookie.gotIt', 'Got it!')}
      cookieName="mathLearningCookieNotice"
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        fontSize: "16px",
        padding: "20px",
        alignItems: "center",
        boxShadow: "0 -2px 20px rgba(0,0,0,0.2)",
        zIndex: 9999
      }}
      buttonStyle={{
        background: "#4CAF50",
        color: "white",
        fontSize: "16px",
        fontWeight: "bold",
        padding: "12px 24px",
        borderRadius: "25px",
        border: "none",
        cursor: "pointer",
        marginLeft: "15px",
        transition: "all 0.3s ease",
        boxShadow: "0 2px 10px rgba(76, 175, 80, 0.3)"
      }}
      contentStyle={{
        display: "flex",
        alignItems: "center",
        flex: "1 0 300px",
        margin: 0
      }}
      sameSite="strict"
      expires={365}
      onAccept={handleGotIt}
    >
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        gap: "20px",
        flexWrap: "wrap"
      }}>
        <img 
          src={getAssetUrl("/assets/img/cookie.png")} 
          alt="Dragon hugging a cookie" 
          style={{ 
            width: "80px", 
            height: "80px",
            flexShrink: 0,
            borderRadius: "10px"
          }} 
        />
        <div style={{ color: "white", lineHeight: "1.5" }}>
          <div style={{ 
            fontSize: "20px", 
            fontWeight: "bold", 
            marginBottom: "8px",
            color: "#FFE082"
          }}>
            {tf('cookie.title', 'How about a cookie?')}
          </div>
          <div style={{ fontSize: "16px", opacity: "0.95", color: "white", lineHeight: "1.4" }}>
            {tf('cookie.message', 'We use strictly necessary cookies for the app to work - no analytics, no marketing, no 3rd parties.')}
          </div>
        </div>
      </div>
    </CookieConsent>
  );
};

export default CookieBanner;